import RequestSupportTermsAndConditionsComponent from "../../components/request-support/request-support-terms-and-conditions";

const RequestSupportTermsAndConditionsPage = () => <RequestSupportTermsAndConditionsComponent />

export default RequestSupportTermsAndConditionsPage;